/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedHeadLinkTags_metadata = {
    readonly canonical: string | null;
    readonly disableIndexing: boolean | null;
    readonly next: string | null;
    readonly prev: string | null;
    readonly " $refType": "SharedHeadLinkTags_metadata";
};
export type SharedHeadLinkTags_metadata$data = SharedHeadLinkTags_metadata;
export type SharedHeadLinkTags_metadata$key = {
    readonly " $data"?: SharedHeadLinkTags_metadata$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedHeadLinkTags_metadata">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedHeadLinkTags_metadata",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canonical",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "disableIndexing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "next",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prev",
      "storageKey": null
    }
  ],
  "type": "MetaData",
  "abstractKey": null
};
(node as any).hash = 'fe44edbfd9fb00feb7d3dea57ccd37d2';
export default node;
